import SoopUiImg from './SoopUiImg';

export default SoopUiImg;
